"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _attachmentRow = _interopRequireDefault(require("./rows/attachment-row"));
var _selectableRow = _interopRequireDefault(require("./rows/selectable-row"));
var _quantitySelectorRow = _interopRequireDefault(require("./rows/quantity-selector-row"));
var _featureBannerRow = _interopRequireDefault(require("./rows/feature-banner-row"));
var _configContext = require("../../context/config-context");
var _functions = require("../../utils/functions");
var _useScrollToNext = _interopRequireDefault(require("../../hooks/useScrollToNext"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable complexity */
/* eslint-disable max-statements */
/* eslint-disable max-len */

const RowContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RowContainer",
  class: "pc-rf7sdvv",
  vars: {
    "rf7sdvv-0": [({
      loading
    }) => loading ? '.5' : 1]
  }
});
const LAYOUTS_ALLOW_LIST = ['quantitySelector', 'featureBanner'];

/**
 * ConfigItemRow Component
 *
 * @param {Object} props React props
 * @param {Object} props.selector Selector object
 * @param {number} props.index Index of the row
 * @returns {React.ReactElement} ConfigItemRow Component
 */
function ConfigItemRow({
  selector,
  index,
  ...rest
}) {
  const {
    configData,
    postLoading,
    updateInstance
  } = (0, _configContext.useConfig)();
  const {
    registerRef,
    scrollToNext
  } = (0, _useScrollToNext.default)();
  const handleDropDownChange = (0, _react.useCallback)(async selectedOption => {
    if (!configData) {
      return;
    }
    const updatedInstance = {
      ...configData.instance
    };
    (0, _functions.updateInstanceTerm)(updatedInstance, selectedOption.instancePath, selectedOption.numberOfTerm);
    try {
      updateInstance(updatedInstance);
      requestAnimationFrame(() => {
        scrollToNext(index);
      });
    } catch (err) {
      throw new Error(`Failed to update config: ${err.message}`);
    }
  }, [configData, updateInstance, scrollToNext, index]);
  const handlePillChange = (0, _react.useCallback)(async selectedOption => {
    if (!configData) {
      return;
    }
    const updatedInstance = {
      ...configData.instance
    };
    (0, _functions.updateSelection)(updatedInstance, selectedOption.instancePath, selectedOption.id);
    try {
      updateInstance(updatedInstance);
      requestAnimationFrame(() => {
        scrollToNext(index);
      });
    } catch (err) {
      throw new Error(`Failed to update config: ${err.message}`);
    }
  }, [configData, updateInstance, scrollToNext, index]);
  const handleAttachmentChange = (0, _react.useCallback)(async (isChecked, inputName, inputValue, isPillToggle) => {
    if (!configData) {
      return;
    }
    const updatedInstance = {
      ...configData.instance
    };
    (0, _functions.updateSelection)(updatedInstance, inputName, isChecked ? inputValue : 'none', isPillToggle);
    try {
      await updateInstance(updatedInstance);
      if (!isPillToggle) {
        requestAnimationFrame(() => {
          scrollToNext(index);
        });
      }
    } catch (err) {
      throw new Error(`Failed to update config: ${err.message}`);
    }
  }, [configData, updateInstance, scrollToNext, index]);
  const handleQuantityChange = (0, _react.useCallback)(async (quantity, product) => {
    if (!configData) {
      return;
    }
    const updatedInstance = {
      ...configData.instance
    };
    if (product) {
      (0, _functions.updateQuantity)(updatedInstance, product, quantity);
      try {
        updateInstance(updatedInstance);
      } catch (err) {
        throw new Error(`Failed to update config: ${err.message}`);
      }
    }
  }, [configData, updateInstance]);
  const {
    _name,
    id,
    layouts,
    title,
    sharedTagLabel,
    description,
    rowTitle,
    rowDisclaimer,
    items,
    flyout,
    defaultSelected,
    inputName,
    inputValue,
    displayDisable,
    split,
    min,
    max,
    instancePath,
    icon,
    image,
    partial,
    list
  } = selector;
  if (!LAYOUTS_ALLOW_LIST.includes(layouts) && (!items || items.length === 0)) {
    return null;
  }
  let area = '';
  let property = '';
  if (layouts === 'toggle') {
    area = items[0]?.instancePath?.split('/')[1];
    property = items[0]?.instancePath?.split('/')[2];
  } else if (layouts === 'pillSelector') {
    area = instancePath?.split('/')[1];
    property = instancePath?.split('/')[2];
  } else if (layouts === 'featureBanner') {
    area = instancePath?.split('/')[1];
    property = instancePath?.split('/')[2];
  }
  return /*#__PURE__*/_react.default.createElement(RowContainer, (0, _extends2.default)({
    "data-cy": layouts
  }, area && property && {
    'data-pc-area': area,
    'data-pc-prop': property
  }, {
    ref: registerRef(index),
    loading: postLoading
  }), (layouts === 'termSelector' || layouts === 'pillSelector') && /*#__PURE__*/_react.default.createElement(_selectableRow.default, {
    _name,
    id,
    items,
    rowTitle,
    rowDisclaimer,
    title,
    description,
    flyout,
    sharedTagLabel,
    defaultSelected,
    handleDropDownChange,
    handlePillChange,
    displayDisable,
    split,
    layouts,
    instancePath
  }), layouts === 'quantitySelector' && /*#__PURE__*/_react.default.createElement(_quantitySelectorRow.default, (0, _extends2.default)({}, rest, {
    title,
    description,
    flyout,
    min,
    max,
    handleChange: handleQuantityChange
  })), layouts === 'featureBanner' && /*#__PURE__*/_react.default.createElement(_featureBannerRow.default, (0, _extends2.default)({}, rest, {
    id,
    rowTitle,
    title,
    description,
    flyout,
    icon,
    image,
    partial,
    list
  })), layouts === 'toggle' && /*#__PURE__*/_react.default.createElement(_attachmentRow.default, {
    items,
    rowTitle,
    handleChange: handleAttachmentChange,
    inputName,
    inputValue
  }));
}
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(ConfigItemRow);
ConfigItemRow.propTypes = {
  layouts: _propTypes.default.oneOf(['toggle', 'termSelector', 'quantitySelector', 'pillSelector', 'none', 'radio', 'featureBanner']),
  rowTitle: _propTypes.default.string,
  rowDisclaimer: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.shape(_attachmentRow.default.propTypes)),
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  flyout: _propTypes.default.object,
  selector: _propTypes.default.object,
  index: _propTypes.default.number
};